import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './nps-feedback-eform.component.scss';
import * as $ from 'jquery';
var NpsFeedbackEform = /** @class */ (function (_super) {
    tslib_1.__extends(NpsFeedbackEform, _super);
    function NpsFeedbackEform(element) {
        var _this = _super.call(this, element) || this;
        _this.count = 1;
        _this.dataChecks = true;
        _this.map = new Map();
        _this.iSstep1Completed = false;
        _this.iSstep2Completed = false;
        _this.iSstep3Completed = false;
        _this.errors = [];
        _this.emptyerrors = [];
        _this.feedbackData = {
            feedback: [
                {
                    id: 1,
                    question: 'How satisfied are you with the Standard Bank Business website?',
                    type: 'rating',
                    scale: '5'
                },
                {
                    id: 2,
                    question: 'How easy was it to use the Standard Bank Business website?',
                    type: 'rating',
                    scale: '5'
                },
                {
                    id: 3,
                    question: 'Please tell us more about your experience',
                    type: 'text'
                }
            ]
        };
        _this.formNames = {
            step1: "give us feedback:how satisfied are you with business website",
            step2: "give us feedback:how easy was it to use business website",
            step3: "give us feedback:please tell us more about your experience"
        };
        return _this;
    }
    NpsFeedbackEform.prototype.init = function () {
        this.modals = Array.from(this.element.querySelectorAll('.js-nps-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-nps-modal-open'));
        this.closeModalButton = this.element.querySelector('.js-nps-modal-close');
        this.openButton = this.element.querySelector('.js-nps-modal-open');
        this.buttonContainer = this.element.querySelector('.nps-toggle');
        this.closeButtonAction = this.element.querySelector('.close-action');
        this.form = this.element.querySelector("form");
        this.wizardStepsContainer = this.element.querySelector(".form-container-wizard__steps");
        this.pollSurvey = document.querySelector(".poll-survey");
        // buttons
        this.closeButton = this.element.querySelector(".js-apply-now-modal-close");
        this.backButton = Array.from(this.element.querySelectorAll(".js_prev-step-button"));
        this.formNames = {
            step1: "give us feedback:how satisfied are you with business website",
            step2: "give us feedback:how easy was it to use business website",
            step3: "give us feedback:please tell us more about your experience"
        };
        this.step1Cont = this.element.querySelector(".step1");
        this.formContainer = this.element.querySelector(".form-container__fields");
        this.step1Button = this.element.querySelector(".js_next-step1-button");
        this.step2Button = this.element.querySelector(".js_next-step2-button");
        this.showStep(1);
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector(".form-container__error");
        }
        this.buttonSubmit = this.element.querySelector(".js_submit-button");
        this.doneSubmit = this.element.querySelector(".js_done-button");
    };
    NpsFeedbackEform.prototype.bindEvents = function () {
        var _this = this;
        this.closeModalButton.addEventListener('click', function () { return _this.closeCallMeBackModal(); });
        this.closeButtonAction.addEventListener('click', function () { return _this.closeCallMeBackModal(); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openCallMeBackModals(event);
            _this.globalApplicationStart();
        }); });
        document.querySelectorAll('.star-rating').forEach(function (ratingGroup) {
            var labels = Array.from(ratingGroup.querySelectorAll('.star-rating__label'));
            var inputs = Array.from(ratingGroup.querySelectorAll('.star-rating__input'));
            function setSelectedByIndex(index) {
                labels.forEach(function (label, i) {
                    if (i >= index)
                        label.classList.add('selected');
                    else
                        label.classList.remove('selected');
                });
            }
            inputs.forEach(function (input, idx) {
                input.addEventListener('change', function () {
                    if (input.checked)
                        setSelectedByIndex(idx);
                });
            });
            // Initialize checked
            var checkedInput = ratingGroup.querySelector('.star-rating__input:checked');
            if (checkedInput) {
                var idx = inputs.indexOf(checkedInput);
                if (idx !== -1)
                    setSelectedByIndex(idx);
            }
        });
        // Rating inputs for q1 and q2
        var ratingInputs = this.form.querySelectorAll('input[type="radio"]');
        ratingInputs.forEach(function (input) {
            input.addEventListener('change', function (event) {
                var target = event.target;
                var questionId = parseInt(target.name.replace('q', ''));
                var feedbackItem = _this.feedbackData.feedback.find(function (item) { return item.id === questionId; });
                if (questionId === 1) {
                    _this.form.setAttribute("data-frmcontainer", _this.formNames["step1"]);
                    _this.analyticsFormStart("step1");
                }
                else if (questionId === 2) {
                    _this.form.setAttribute("data-frmcontainer", _this.formNames["step2"]);
                    _this.analyticsFormStart("step2");
                }
                if (feedbackItem) {
                    feedbackItem.response = target.value;
                }
            });
        });
        // Text input for q3
        var textArea = this.form.querySelector('textarea[name="response"]');
        if (textArea) {
            textArea.addEventListener('input', function (event) {
                var target = event.target;
                var feedbackItem = _this.feedbackData.feedback.find(function (item) { return item.id === 3; });
                if (feedbackItem) {
                    _this.analyticsFormStart("step3");
                    feedbackItem.response = target.value;
                }
            });
        }
        //Step 1 Next Button
        if (this.step1Button) {
            this.step1Button.addEventListener("click", function (pEvent) {
                _this.form.setAttribute("data-frmcontainer", _this.formNames["step2"]);
                _this.analyticsFormComplete("step1", _this.feedbackData.feedback[0].response);
                _this.globalFormComplete();
                var _form = _this.form.querySelector(".step1");
                if (_form) {
                    var formFields = _form.querySelectorAll("input, select");
                    _this.validationService.validate(formFields);
                    var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                    var validContact = Array.from(_form.querySelectorAll(".form__group--error_message"));
                    if (valid.length === 0 && validContact.length === 0) {
                        _this.count += 1;
                        _this.iSstep1Completed = true;
                        _this.showStep(2);
                    }
                }
            });
        }
        //Step 2 Next Button
        if (this.step2Button) {
            this.step2Button.addEventListener("click", function (pEvent) {
                _this.form.setAttribute("data-frmcontainer", _this.formNames["step3"]);
                _this.analyticsFormComplete("step2", _this.feedbackData.feedback[1].response);
                _this.globalFormComplete();
                var _form = _this.form.querySelector(".step2");
                if (_form) {
                    var formFields = _form.querySelectorAll("input, select");
                    _this.validationService.validate(formFields);
                    var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                    _this.dataChecks = true;
                    if (valid.length === 0) {
                        if (!_this.dataChecks) {
                            _this.showDisplayView("decline");
                            window.scrollTo(0, 0);
                        }
                        else {
                            _this.count += 1;
                            _this.iSstep2Completed = true;
                            _this.showStep(3);
                        }
                    }
                }
            });
        }
        //Step 3 Submit Button Click
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step3");
                if (_form) {
                    var intervalId_1 = setInterval(function () {
                        if (_this.pollSurvey) {
                            _this.pollSurvey.classList.remove("poll-survey--hidden");
                            if (!_this.pollSurvey.classList.contains("poll-survey--hidden")) {
                                clearInterval(intervalId_1);
                            }
                        }
                    }, 1000);
                    var textarea = _form.querySelector('textarea[name="response"]');
                    var formFields = _form.querySelectorAll("input, select, textarea");
                    // Clear any existing error state
                    textarea.closest('.form__group').classList.remove('form__group--error');
                    var existingError = textarea.closest('.form__group').querySelector('.form__group--error_message');
                    if (existingError) {
                        existingError.remove();
                    }
                    // Validate textarea
                    if (!textarea.value.trim()) {
                        textarea.closest('.form__group').classList.add('form__group--error');
                        var errorMessage = document.createElement('div');
                        errorMessage.className = 'form__group--error_message';
                        errorMessage.textContent = 'Please provide your feedback';
                        textarea.closest('.form__group').appendChild(errorMessage);
                        return;
                    }
                    _this.validationService.validate(formFields);
                    var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                    if (valid.length === 0) {
                        // Update the feedback data before submitting
                        var feedbackItem = _this.feedbackData.feedback.find(function (item) { return item.id === 3; });
                        if (feedbackItem) {
                            feedbackItem.response = textarea.value.trim();
                            _this.globalFormComplete();
                            _this.analyticsFormComplete("step3", feedbackItem.response);
                        }
                        _this.iSstep3Completed = true;
                        _this.submitForm(_this.form);
                    }
                }
            });
        }
        //Back button
        if (this.backButton.length) {
            this.backButton.map(function (item) {
                return item.addEventListener("click", function (event) {
                    _this.showPreviousStep(event);
                });
            });
        }
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener("click", function () {
                _this.resetForm();
                _this.closeCallMeBackModal();
            });
        }
        if (this.closeButton) {
            this.closeButton.addEventListener("click", function () { return _this.resetForm(); });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    NpsFeedbackEform.prototype.analyticsApplicationComplete = function () {
        if ((typeof dataLayer != 'undefined')) {
            dataLayer = tslib_1.__assign({}, dataLayer, { application: tslib_1.__assign({}, dataLayer.application, { applicationStep: "Step 4", applicationName: "application:business:give us feedback" }) });
        }
        if ((typeof _satellite != 'undefined')) {
            _satellite.track("globalApplicationComplete");
        }
    };
    NpsFeedbackEform.prototype.analyticsFormStart = function (step) {
        if ((typeof dataLayer != 'undefined')) {
            dataLayer = tslib_1.__assign({}, dataLayer, { formisSubmitted: false, formName: this.formNames[step], formStatus: "", application: tslib_1.__assign({}, dataLayer.application, { applicationName: "application:business:give us feedback", applicationStep: "Step " + (step === "step1" ? "1" : step === "step2" ? "2" : "3") }) });
        }
    };
    NpsFeedbackEform.prototype.globalApplicationStart = function () {
        if ((typeof dataLayer != 'undefined')) {
            dataLayer = tslib_1.__assign({}, dataLayer, { application: tslib_1.__assign({}, dataLayer.application, { applicationName: "application:business:give us feedback", applicationStep: "Step 1" }) });
        }
        if (typeof _satellite != 'undefined') {
            _satellite.track("globalApplicationStart");
        }
    };
    NpsFeedbackEform.prototype.globalFormComplete = function () {
        if ((typeof _satellite != 'undefined')) {
            _satellite.track("globalFormComplete");
        }
    };
    NpsFeedbackEform.prototype.analyticsFormComplete = function (step, options) {
        if (options === void 0) { options = ""; }
        if ((typeof dataLayer != 'undefined')) {
            dataLayer = tslib_1.__assign({}, dataLayer, { formisSubmitted: true, formName: step !== "step3" ? this.formNames[step] : "give us feedback:please tell us more about your experience", formStatus: "complete" }, (step !== "step3" ? { surveyID: "business:give us feedback" } : {}), (step !== "step3" ? { surveyRating: options } : {}));
        }
    };
    NpsFeedbackEform.prototype.getCallMeBackModalById = function (id) {
        return document.querySelector("#" + id);
    };
    NpsFeedbackEform.prototype.showOpenButton = function () {
        var _this = this;
        this.closeModalButton.classList.remove('nps-toggle__toggle-icon--visible');
        setTimeout(function () {
            _this.buttonContainer.classList.add('nps-toggle--closed');
        }, 150);
        setTimeout(function () {
            _this.openButton.classList.add('nps-toggle__toggle-text--visible');
        }, 300);
    };
    NpsFeedbackEform.prototype.showCloseButton = function () {
        var _this = this;
        this.openButton.classList.remove('nps-toggle__toggle-text--visible');
        setTimeout(function () {
            _this.buttonContainer.classList.remove('nps-toggle--closed');
        }, 150);
        setTimeout(function () {
            _this.closeModalButton.classList.add('nps-toggle__toggle-icon--visible');
        }, 300);
    };
    NpsFeedbackEform.prototype.isClickOutsideCallMeBackModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeCallMeBackModal();
        }
    };
    NpsFeedbackEform.prototype.openCallMeBackModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (!modalId) {
            var parentElement = $(element).closest('.js-nps-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        this.activeModal = this.getCallMeBackModalById(modalId);
        this.openCallMeBackModal();
    };
    NpsFeedbackEform.prototype.closeCallMeBackModal = function () {
        var _this = this;
        this.analyticsService.dtmFormAbandon();
        this.activeModal.classList.add('modal--close');
        this.activeModal.querySelector('.nps__modal-dialog').classList.remove('nps__modal-dialog--open');
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
        this.showOpenButton();
    };
    NpsFeedbackEform.prototype.openCallMeBackModal = function () {
        this.resetForm();
        this.activeModal.classList.remove('modal--close');
        this.activeModal.classList.remove('modal--closed');
        this.activeModal.querySelector('.nps__modal-dialog').classList.add('nps__modal-dialog--open');
        this.showCloseButton();
    };
    NpsFeedbackEform.prototype.resetForm = function () {
        this.displaySuccess.classList.add("hidden");
        this.step1Cont.classList.remove("form-container-wizard__steps--hidden");
        this.formContainer.classList.remove("hidden");
        this.form.reset();
        this.showStep(1);
        document.querySelectorAll('.star-rating').forEach(function (ratingGroup) {
            var labels = Array.from(ratingGroup.querySelectorAll('.star-rating__label'));
            labels.forEach(function (label) {
                label.classList.remove('selected');
            });
        });
    };
    NpsFeedbackEform.prototype.showStep = function (stepId) {
        var showStep = parseFloat(stepId);
        if (showStep === 1) {
            this.form.setAttribute("data-frmcontainer", this.formNames["step1"]);
        }
        else if (showStep === 2) {
            this.form.setAttribute("data-frmcontainer", this.formNames["step2"]);
        }
        else if (showStep === 3) {
            this.form.setAttribute("data-frmcontainer", this.formNames["step3"]);
        }
        var _steps = Array.from(this.wizardStepsContainer.querySelectorAll(".form-container-wizard__steps--step"));
        var _heading = "";
        _steps.map(function (pStep) {
            var _step = parseFloat(pStep.getAttribute("data-step"));
            if (_step == showStep) {
                _heading = pStep.getAttribute("data-heading");
                pStep.classList.remove("form-container-wizard__steps--hidden");
            }
            else {
                pStep.classList.add("form-container-wizard__steps--hidden");
            }
        });
        window.scrollTo(0, 0);
    };
    NpsFeedbackEform.prototype.showPreviousStep = function (event) {
        this.showDisplayView("");
        var _target = event.currentTarget;
        var _currentStep = _target.closest("[data-step]");
        var _nextStep = _currentStep.getAttribute("data-step");
        this.showStep(parseFloat(_nextStep));
        window.scrollTo(0, 0);
    };
    NpsFeedbackEform.prototype.submitForm = function (form) {
        var _this = this;
        // Add submission timestamp
        this.feedbackData.submittedAt = new Date().toISOString();
        var _postData = tslib_1.__assign({}, this.feedbackData);
        this.showDisplayView("loader");
        var url = this.baseUrl + "/bcleadUtils/nps-feedback";
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, _postData, _config)
            .then(function (pResponse) {
            if (pResponse.data === "invalid") {
                _this.showDisplayView("error");
            }
            else {
                _this.iSstep3Completed = true;
                _this.showDisplayView("success");
                _this.analyticsApplicationComplete();
            }
        })
            .catch(function (pError) {
            // service failed
            _this.showDisplayView("error");
        });
    };
    NpsFeedbackEform.prototype.showDisplayView = function (pDisplay) {
        window.scroll({ top: 50, behavior: "smooth" });
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
        }
    };
    return NpsFeedbackEform;
}(Base));
export { NpsFeedbackEform };



//////////////////
// WEBPACK FOOTER
// ./components/nps-feedback-eform/nps-feedback-eform.component.ts
// module id = 1092
// module chunks = 0